import React from 'react';

export const Unauthenticated = () => {
  return (
    <div className="loader">
      <div className="error-container">
        <div className="message-title">Access Denied</div>
        <div className="message-body">
          <div className="message mt-1 text-center">
            Sorry, you don&apos;t have permission to access this content. Please log in or check your credentials and
            try again.
          </div>
          <div className="message">
            {'Please, try again '}
            <a className="message" href="/login">
              here
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
